module.exports = __webpack_public_path__ + "img/invoice-de-female-be.2ffab6de.png";